import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Container, Grid, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    CheckCIBILScore as CIBILScore,
    CIBILDownloadPDF
} from 'Components/Api/CIBILScoreAPI';

import {
    CIBIL_SCORE_CODE,
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import PayIcon from 'Components/SvgButtons/PayIcon';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';

const CustomContainer = HOCLoader(Container);

export const CheckCIBILScore = () => {
    const classes = commonStyle();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const formRef = useRef();
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [RefreshRandom, setRefreshRandom] = useState(0);
    const [serviceCode, setserviceCode] = useState(CIBIL_SCORE_CODE);
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [Operator, setOperator] = useState([]);

    const [formObj, setFormObj] = useState({
        Name: '',
        MobileNumber: '',
        PanNumber: '',
        DateOFBirth: '',
        address: '',
        pincode: '',
        Pin: ''
    });

    const validationSchema = Yup.object({
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),

        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'mobile number'),

        PanNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'pan number'),

        DateOFBirth: Yup.string().required('Please provide a valid date of birth').matches(/^\d{4}-\d{2}-\d{2}$/,
            'Date of birth must be in the format yyyy-mm-dd'),

        address: Yup.string().required(PLEASE_PROVIDE_VALID + 'address'),

        pincode: Yup.string().required(PLEASE_PROVIDE_VALID + 'pincode'),

        Pin: Yup.number().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.number().required('Please enter pin')
        })
    });

    const reset = () => {
        setFormObj({
            Name: '',
            MobileNumber: '',
            PanNumber: '',
            DateOFBirth: '',
            address: '',
            pincode: '',
            Pin: ''
        });
    };

    useEffect(() => {
        setLoadingOpen(true);
        selectOperator(serviceCode);
    }, []);


    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) return;
        values.ServiceID = CIBIL_SCORE_CODE;
        await Procced(values, { setSubmitting, resetForm });
    };


    const Procced = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);
        setResponseMessage('');
        setIsError(false);

        let response = '';
        var requestObj = {
            Name: values.Name,
            MobileNumber: values.MobileNumber,
            PanNumber: values.PanNumber,
            DateOFBirth: values.DateOFBirth,
            address: values.address,
            pincode: values.pincode,
            Pin: values.Pin,
            ServiceID: values.ServiceID, 
        };
        var request = JSON.stringify(requestObj);
        response = await CIBILScore(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setRefreshRandom(Math.random(0));

        var data = JSON.parse(response.data);  
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }
        setSeverity('success');
        setStatus(data.Status);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        setIsError(true);

        if (data.Status === 'FAILURE') setSeverity('error');
        reset();
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={6} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Name"
                                                        name="Name"
                                                        placeholder="Name"
                                                        title="Name"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField

                                                        label="Mobile"
                                                        name="MobileNumber"
                                                        icon="Mobile"
                                                        placeholder="Mobiler"
                                                        title="mobile"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Pan Number"
                                                        name="PanNumber"
                                                        placeholder="Pan Number"
                                                        title="Pan Number"
                                                        length="10"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Date Of Birth"
                                                        name="DateOFBirth"
                                                        placeholder="Date Of Birth"
                                                        title="Date Of Birth"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Address"
                                                        name="address"
                                                        placeholder="Address"
                                                        title="Address"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Pincode"
                                                        type="Pincode"
                                                        name="pincode"
                                                        placeholder="Pincode"
                                                        title="Pincode"
                                                        length={6}
                                                    />
                                                </Grid>

                                                {isPin === 'true' ? (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                    >
                                                        <MaterialNumberField
                                                            label="Pin"
                                                            type="password"
                                                            name="Pin"
                                                            placeholder="Pin"
                                                            title="Pin"
                                                            length={4}
                                                        />
                                                    </Grid>
                                                ) : null}

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    spacing={2}
                                                    container
                                                    className={classes.footerGrid}
                                                >
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={6}
                                                        lg={6}
                                                    >
                                                        <SecondaryButton
                                                            size="large"
                                                            type="reset"
                                                            title="Reset"
                                                            endIcon={<ResetIcon />}
                                                        ></SecondaryButton>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={6}
                                                        lg={6}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="Check CIBIL"
                                                            endIcon={<PayIcon />}
                                                            disabled={loadingOpen}
                                                        ></PrimaryButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={CIBIL_SCORE_CODE}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );

};
